import * as React from 'react';
import classnames from 'classnames';

import OfferBannerContext from '../context/OfferBannerContext';
import OfferBannerDetails from '../details/OfferBannerDetails';

import { __t, applyTranslations } from 'utils/language';
import { FUNC_RETURN_NULL } from '../utils/offer-banner';

import './offer-banner-pending.scss';

applyTranslations(require('./offer-banner-pending.i18n.json'));

const MSG_KEY = 'offer_banner_pending';

const OfferBannerPending: React.FC = () => {
  const context = React.useContext(OfferBannerContext);
  const {
    offer,
    updatedOffer,
    brandProfileName,
    isNewOffer,
    isRenegotiation,
    isBrand,
    renderPrimaryText = FUNC_RETURN_NULL,
    renderStatus = FUNC_RETURN_NULL,
    renderDisclaimer = FUNC_RETURN_NULL,
    renderCreatorActions = FUNC_RETURN_NULL
  } = context;

  const currentOffer = isNewOffer || !isRenegotiation ? offer : updatedOffer;
  const statusText = __t(`${MSG_KEY}.messages.pending_acceptance`);

  const primaryTextKey = isBrand ? 'binding_offer' : 'brand_offers_you';
  const primaryText = __t(`${MSG_KEY}.labels.${primaryTextKey}`, {
    brandProfileName
  });

  const containerClasses = classnames('offer-banner-pending', {
    [`offer-banner-pending--${currentOffer?.state}`]: true
  });

  return (
    <React.Fragment>
      <div className={containerClasses}>
        {renderPrimaryText(primaryText)}
        <OfferBannerDetails
          offer={currentOffer}
          budgetLabel={__t(`${MSG_KEY}.labels.budget_offer`)}
          showAdditionalCompensationDescriptions
        />
        { isBrand && renderStatus(statusText) }
        { !isBrand && renderCreatorActions() }
      </div>
      {renderDisclaimer('offer_pending')}
    </React.Fragment>
  );
};

export default OfferBannerPending;
